import { render, staticRenderFns } from "./ReferralStatistics.vue?vue&type=template&id=ab2f78d8"
import script from "./ReferralStatistics.vue?vue&type=script&lang=js"
export * from "./ReferralStatistics.vue?vue&type=script&lang=js"
import style0 from "./ReferralStatistics.vue?vue&type=style&index=0&id=ab2f78d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports